'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { earnSunsetPhaseBunja } from '@flipster/features/src/flipster-earn/sunset/phase-bunja';
import { EarnSunsetModalHost } from '@flipster/features/src/flipster-earn/sunset/sunset-modal/host';
import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import { Banner } from './sections/1-banner';
import { OverviewSection } from './sections/2-overview';
import { BeforeParticipationEarnAprSection } from './sections/3-apr/before-participation-earn-apr-section';
import { BufferEarnAprSection } from './sections/3-apr/buffer-earn-apr-section';
import { YourEarnAprSection } from './sections/3-apr/your-earn-apr-section';
import { ExchangeWinnersSection } from './sections/4-exchange-winners';
import { EarnHistorySection } from './sections/5-history';
import { Faq } from './sections/6-faq';
import { earnPageBunja } from './state';

const Page = () => {
  const { hasFirstDepositAtom } = useBunja(earnPageBunja);
  const { isEarnSunsetBufferAtom } = useBunja(earnSunsetPhaseBunja);
  const hasFirstDeposit = useAtomValue(hasFirstDepositAtom);
  const isEarnSunsetBuffer = useAtomValue(isEarnSunsetBufferAtom);

  return (
    <main
      className={css({
        w: '100%',
        px: 16,
        maxW: 992,
        mx: 'auto',
        pb: { base: 80, tablet: 150 },
        pt: { base: 32, tablet: 80 },
      })}
    >
      <EarnSunsetModalHost />
      <h1
        className={css({
          textStyle: 'Display/XL',
          color: 'content.default.level-5',
          mb: { base: 20, tablet: 40 },
        })}
      >
        <FormattedMessage id='Autogen_common.r251126.s_Earn' />
      </h1>
      <div className={stack({ gap: { base: 32, tablet: 64 } })}>
        <Banner />
        {hasFirstDeposit && <OverviewSection />}
        {isEarnSunsetBuffer ? (
          <BufferEarnAprSection />
        ) : (
          <>
            {hasFirstDeposit && <YourEarnAprSection />}
            {!hasFirstDeposit && <BeforeParticipationEarnAprSection />}
          </>
        )}
        <ExchangeWinnersSection />
        {hasFirstDeposit && <EarnHistorySection />}
        <Faq />
      </div>
    </main>
  );
};

export default Page;
